import * as React from 'react'
import styled from 'styled-components'
import { FieldArray, getIn, connect, FormikContext } from 'formik'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Columns,
  Column,
  Button,
  Icon
} from '@espoon-voltti/react-components/elements'
import { EuroCents } from '@espoon-voltti/ts-libs/lib/euro'

import { Transaction } from '@espoon-voltti/nuora-domain/grants'

import { t } from '../../../../../i18n'
import { ProjectGrantDraftApp } from '../../../../../domain'
import { FormSumField } from './sum-field'
import { TransactionRow } from './row'

const createTransactionRow = (): Transaction => ({
  description: '',
  amount: EuroCents.zero()
})

interface TransactionsProps {
  name: 'expenses' | 'incomes'
}

const RowsWrapper = styled.div`
  margin-top: 20px;
`

const TransactionsImpl = ({
  formik,
  name
}: TransactionsProps & { formik: FormikContext<ProjectGrantDraftApp> }) => {
  const values = (getIn(formik.values, `form.${name}`) as any[]) || []

  const handleAdd = (add: (row: Transaction) => void) => () =>
    add(createTransactionRow())

  const handleRemove = (remove: (i: number) => void, index: number) => () =>
    remove(index)

  return (
    <FieldArray name={`form.${name}`}>
      {({ remove, push }) => (
        <div data-qa="transactions">
          <RowsWrapper>
            {values.map((_, i) => (
              <TransactionRow
                label={name}
                key={i}
                name={`form.${name}[${i}]`}
                canRemove={values.length > 1}
                onRemove={handleRemove(remove, i)}
              />
            ))}
          </RowsWrapper>
          <Columns>
            <Column className={'is-paddingless'} size={8}>
              <Button plain={true} onClick={handleAdd(push)} dataQa={'addRow'}>
                <Icon icon={faPlus} />
                {t(['views', 'form', 'expensesAndIncomes', name, 'add'])}
              </Button>
            </Column>
            <Column size={2}>
              <FormSumField
                dataQa={'sumField'}
                name={`form.${name}`}
                label={t([
                  'views',
                  'form',
                  'expensesAndIncomes',
                  name,
                  'totalSum'
                ])}
                values={values}
              />
            </Column>
            <Column size={2} />
          </Columns>
        </div>
      )}
    </FieldArray>
  )
}

export const Transactions = connect<TransactionsProps, ProjectGrantDraftApp>(
  TransactionsImpl
)
